<template>
  <ModalContainer :show="show">
    <template slot="body">
      <div class="modal-content">
        <div class="d-flex align-items-center justify-content-between">
          <span class="ml-1 font-18 font-bold">{{ $t("export") }}</span>
          <img
            src="../../assets/images/Vector (1).png"
            alt="close"
            class="cursor-pointer  mt-1 mr-1"
            @click="$emit('close')"
          />
        </div>

        <div
          class="d-flex flex-column align-items-center justify-contents-center p-10"
        >
          <div class="w-100 mt-4">
            <!-- <label for="timezone">{{ timezone }}</label> -->
            <div
              class="input d-flex align-items-center justify-content-between p-15 cursor-pointer"
              @click="show_globe = !show_globe"
              id="timezone"
            >
              <span v-if="!currentTimezone">{{ $t("select_timezone") }}</span>
              <span v-else>{{ currentTimezone }}</span>
              <icon-dropdown />
            </div>

            <div
              class="dropdown-lang position-absolute p-20 pt-3 w-100"
              v-if="show_globe"
              v-click-outside="hideGlobe"
            >
              <table-search
                containerClass="w-100 mb-2"
                @handleSearch="
                  ($event) => (searchTimezone = $event.target.value)
                "
                :searchQuery="searchTimezone"
              />

              <div class="timezone-container">
                <div
                  v-for="timezone in filteredTimezones"
                  :key="timezone"
                  class="timezone"
                  @click="timezoneClicked"
                  :class="{ 'active-zone': timezone === currentTimezone }"
                >
                  {{ timezone }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="btn-mt d-flex justify-contents-end align-items-center col-gap-2 ml-auto"
          >
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="$emit('openExport')"
              :disabled="!currentTimezone"
            >
              {{ $t("export") }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </ModalContainer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import IconDropdown from "../../components/Iconsvg/IconDropdown.vue";
import ModalContainer from "../../components/ModalContainer";
import TableSearch from "../../components/TableSearch.vue";
import vClickOutside from "v-click-outside";

export default {
  name: "Timezone",
  components: {
    ModalContainer,
    IconDropdown,
    TableSearch,
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      show_globe: false,
      searchTimezone: "",
      timezones: [],
    };
  },
  computed: {
    ...mapGetters(["reportTimezones", "currentTimezone"]),
    filteredTimezones() {
      return this.reportTimezones.filter((timezone) =>
        timezone.toLowerCase().includes(this.searchTimezone.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions(["setTimezone"]),
    hideGlobe() {
      this.show_globe = false;
    },
    timezoneClicked(event) {
      this.setTimezone(event.target.innerText);
      this.show_globe = false;
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
</script>

<style scoped>
.modal-content {
  width: 100%
}
.body {
  padding: 50px;
}
.input {
  background: rgba(240, 244, 251, 0.6) !important;
}
.timezone {
  padding: 10px 5px;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
}

.active-zone {
  background: #dee2eb;
  color: #213e7a;
}
.timezone-container {
  height: 17rem;
  overflow-y: scroll;
}
.search-timezone {
  background: white;
}
.active-zone {
  background: #dee2eb;
  color: #213e7a;
}
.dropdown-lang {
  background: #ffffff;
  /* border: 0.3px solid rgba(99, 99, 99, 0.25); */
  box-shadow: 0px 20px 50px rgba(29, 53, 71, 0.06);
  border-radius: 3px;
  z-index: 3 !important;
  top: 8rem;
  color: #5e6a79;
  /* width: calc(100% - 1.5rem); */
  width: max-content;
}

.btn-mt {
  margin-top: 8rem;
}

@media (max-width: 575.98px) {
  .modal-content {
    width: 100% !important;
  }
}
</style>
